import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { Spinner } from '@agro-club/agroclub-shared'

type Props = {
  hasData: boolean | undefined
}

export const SummaryThereIsWithLoader: FC<Props> = ({ hasData }) => {
  const { t } = useTranslation('common')

  if (hasData === undefined) {
    return <Spinner size="small" />
  }

  return <div>{hasData ? t('thereIs') : t('no')}</div>
}
